import { memo } from 'react';

import { workspaceAgentHeroUserPromptBubble } from '~/components/v2/components/workspace/workspace-agent-panel/constants/workspaceAgentHeroChrome';
import { type WorkspaceAgentIconComponent } from '~/components/v2/components/workspace/workspace-agent-panel/design-system/types';

export type WorkspaceAgentHeroUserPromptBubbleProps = {
  description: string;
  icon: WorkspaceAgentIconComponent;
  title: string;
};

export const WorkspaceAgentHeroUserPromptBubble = memo(
  ({ description, icon: Icon, title }: WorkspaceAgentHeroUserPromptBubbleProps) => {
    const styles = workspaceAgentHeroUserPromptBubble();

    return (
      <div className={styles.root()} data-testid="WORKSPACE_AGENT_HERO_USER_PROMPT_BUBBLE">
        <Icon aria-hidden className={styles.icon()} size="sm" />
        <span className="min-w-0">
          <span className={styles.title()} data-testid="WORKSPACE_AGENT_HERO_USER_PROMPT_TITLE">
            {title}
          </span>
          <span className={styles.description()} data-testid="WORKSPACE_AGENT_HERO_USER_PROMPT_DESCRIPTION">
            {description}
          </span>
        </span>
      </div>
    );
  },
);

WorkspaceAgentHeroUserPromptBubble.displayName = 'WorkspaceAgentHeroUserPromptBubble';
